import { extendTheme, HTMLChakraProps, ThemingProps } from '@chakra-ui/react';
import { CardComponent } from './additions/card/card';
import { buttonStyles } from './components/button';
import { breakpoints } from './foundations/breakpoints';
import { globalStyles } from './styles';

// Create sophisticated Andruil theme with professional furniture industry colors
const theme = extendTheme(
  { breakpoints }, // Responsive breakpoints
  globalStyles, // Global styles with Andruil color palette
  buttonStyles, // Enhanced button styles
  CardComponent, // Sophisticated card component
);

export default theme;

export interface CustomCardProps extends HTMLChakraProps<'div'>, ThemingProps {} 